import HostApi from "../../settings/HostApi";
import { API_URL } from "../../../config/env";

const BASE_URL = API_URL;

// El backend puede devolver tokens no válidos para JSON (NaN / Infinity), por ejemplo
// cuando un porcentaje de inspección no se puede calcular. `response.json()` truena con
// esos tokens, así que leemos el texto crudo, lo saneamos a `null` y luego parseamos.
//
// Con `strict` un fallo del servicio (5xx, red) lanza en vez de devolver `null`, para poder
// distinguir "no tiene inspección" (404) de "no se pudo consultar". Sin `strict` todo es `null`.
const GetColserAutoByPlacaApiImpl = async (placa: string, options?: { strict?: boolean }): Promise<any | null> => {
    try {
        const response = await fetch(`${BASE_URL}/v2/colserauto/inspeccion/`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: HostApi.getToken(),
            },
            body: JSON.stringify({ placa }),
        });

        if (!response.ok) {
            if (options?.strict && response.status !== 404) throw new Error(`Colserauto respondió ${response.status}`);
            return null;
        }

        const text = await response.text();
        const sanitized = text.replace(/\bNaN\b/g, "null").replace(/-?\bInfinity\b/g, "null");

        return JSON.parse(sanitized);
    } catch (error) {
        if (options?.strict) throw error;
        return null;
    }
};

export default GetColserAutoByPlacaApiImpl;
